import React from "react";

export default ({ width = 16, height = 16, fill = "#02af8e", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9987 2.00033C11.2623 2.00033 10.6654 2.59728 10.6654 3.33366C10.6654 4.07004 11.2623 4.66699 11.9987 4.66699C12.7351 4.66699 13.332 4.07004 13.332 3.33366C13.332 2.59728 12.7351 2.00033 11.9987 2.00033ZM9.33203 3.33366C9.33203 1.8609 10.5259 0.666992 11.9987 0.666992C13.4715 0.666992 14.6654 1.8609 14.6654 3.33366C14.6654 4.80642 13.4715 6.00033 11.9987 6.00033C10.5259 6.00033 9.33203 4.80642 9.33203 3.33366Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.9987 6.66634C3.26232 6.66634 2.66536 7.26329 2.66536 7.99967C2.66536 8.73605 3.26232 9.33301 3.9987 9.33301C4.73508 9.33301 5.33203 8.73605 5.33203 7.99967C5.33203 7.26329 4.73508 6.66634 3.9987 6.66634ZM1.33203 7.99967C1.33203 6.52692 2.52594 5.33301 3.9987 5.33301C5.47146 5.33301 6.66536 6.52692 6.66536 7.99967C6.66536 9.47243 5.47146 10.6663 3.9987 10.6663C2.52594 10.6663 1.33203 9.47243 1.33203 7.99967Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9987 11.3333C11.2623 11.3333 10.6654 11.9303 10.6654 12.6667C10.6654 13.403 11.2623 14 11.9987 14C12.7351 14 13.332 13.403 13.332 12.6667C13.332 11.9303 12.7351 11.3333 11.9987 11.3333ZM9.33203 12.6667C9.33203 11.1939 10.5259 10 11.9987 10C13.4715 10 14.6654 11.1939 14.6654 12.6667C14.6654 14.1394 13.4715 15.3333 11.9987 15.3333C10.5259 15.3333 9.33203 14.1394 9.33203 12.6667Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.14936 8.67097C5.33474 8.35285 5.7429 8.24524 6.06102 8.43061L10.6144 11.0839C10.9325 11.2693 11.0401 11.6775 10.8547 11.9956C10.6693 12.3137 10.2612 12.4213 9.94305 12.236L5.38972 9.58262C5.0716 9.39725 4.96399 8.98909 5.14936 8.67097Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8478 4.00361C11.0334 4.32161 10.9261 4.72984 10.6081 4.91542L6.06139 7.56875C5.74339 7.75433 5.33516 7.64698 5.14958 7.32898C4.964 7.01098 5.07135 6.60275 5.38935 6.41717L9.93602 3.76384C10.254 3.57826 10.6622 3.68561 10.8478 4.00361Z"
        fill={fill}
      />
    </svg>
  );
};
